

const defaults = {
	showSubscribeLecture: false,
	qrcodes: {},
	lecture: {},
	callback: null
};


export default (state=defaults, action) => {
	switch(action.type){
		case 'SHOW_SUBSCRIBE_LECTURE':
			return {...state, showSubscribeLecture: true,
        lectureQrcode: action.payload.lectureQrcode,
				lecture: action.payload.lecture,
				callback: action.payload.callback
			};
		case 'HIDE_SUBSCRIBE_LECTURE':
			return {...state, showSubscribeLecture: false};
		default:
			return state;
	}
}





// WEBPACK FOOTER //
// ./src/reducers/subscribeLecture.js